class ReferenceTooltip {
  constructor() {
    this.init();
  }

  init() {
    const tooltipContainers = document.querySelectorAll('.reference-tooltip-container');
    
    // If no tooltip containers found, exit gracefully
    if (tooltipContainers.length === 0) {
      return;
    }
    
    tooltipContainers.forEach(container => {
      const icon = container.querySelector('.reference-icon');
      const tooltip = container.querySelector('.reference-tooltip');
      
      if (!icon || !tooltip) {
        console.warn('Reference tooltip: Missing icon or tooltip element');
        return;
      }

      let hoverTimeout = null;
      let isHovering = false;

      const showTooltip = () => {
        isHovering = true;
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
          hoverTimeout = null;
        }
        this.showTooltip(tooltip, container);
      };

      const hideTooltip = () => {
        isHovering = false;
        if (hoverTimeout) {
          clearTimeout(hoverTimeout);
        }
        hoverTimeout = setTimeout(() => {
          if (!isHovering) {
            this.hideTooltip(tooltip);
          }
        }, 300);
      };

      // Show tooltip on hover
      icon.addEventListener('mouseenter', showTooltip);

      // Hide tooltip when leaving icon
      icon.addEventListener('mouseleave', (e) => {
        // Check if we're moving to the tooltip
        const relatedTarget = e.relatedTarget;
        if (!tooltip.contains(relatedTarget)) {
          hideTooltip();
        }
      });

      // Keep tooltip open when hovering over it
      tooltip.addEventListener('mouseenter', showTooltip);

      // Hide tooltip when leaving tooltip
      tooltip.addEventListener('mouseleave', (e) => {
        // Check if we're moving to the icon
        const relatedTarget = e.relatedTarget;
        if (!icon.contains(relatedTarget)) {
          hideTooltip();
        }
      });

      // Hide tooltip when leaving container
      container.addEventListener('mouseleave', (e) => {
        const relatedTarget = e.relatedTarget;
        if (!tooltip.contains(relatedTarget) && !icon.contains(relatedTarget)) {
          isHovering = false;
          this.hideTooltip(tooltip);
        }
      });

      // Touch events for mobile
      icon.addEventListener('touchstart', (e) => {
        e.preventDefault();
        this.toggleTooltip(tooltip, container);
      });

      // Close tooltip when clicking outside
      document.addEventListener('click', (e) => {
        if (!container.contains(e.target)) {
          this.hideTooltip(tooltip);
        }
      });
    });
  }

  showTooltip(tooltip, container) {
    // Position the tooltip
    this.positionTooltip(tooltip, container);
    
    // Show the tooltip
    tooltip.classList.add('active');
  }

  hideTooltip(tooltip) {
    tooltip.classList.remove('active');
  }

  toggleTooltip(tooltip, container) {
    if (tooltip.classList.contains('active')) {
      this.hideTooltip(tooltip);
    } else {
      this.showTooltip(tooltip, container);
    }
  }

    positionTooltip(tooltip, container) {
    const icon = container.querySelector('.reference-icon');
    if (!icon) {
      console.warn('Reference tooltip: Icon not found for positioning');
      return;
    }
    
    // Reset positioning to default
    tooltip.style.position = 'absolute';
    tooltip.style.left = '50%';
    tooltip.style.bottom = '100%';
    tooltip.style.top = 'auto';
    tooltip.style.transform = 'translateX(-50%)';
    tooltip.style.marginBottom = '6px';
    tooltip.style.marginTop = '0';

    // Force a reflow to get the actual tooltip dimensions
    tooltip.offsetHeight;
    const tooltipRect = tooltip.getBoundingClientRect();
    const iconRect = icon.getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;

    // Check if tooltip would go off the left edge
    const tooltipLeft = iconRect.left + (iconRect.width / 2) - (tooltipRect.width / 2);
    if (tooltipLeft < 10) {
      tooltip.style.left = '0';
      tooltip.style.transform = 'none';
    }

    // Check if tooltip would go off the right edge
    const tooltipRight = tooltipLeft + tooltipRect.width;
    if (tooltipRight > viewportWidth - 10) {
      tooltip.style.left = 'auto';
      tooltip.style.right = '0';
      tooltip.style.transform = 'none';
    }

    // Check if tooltip would go off the top edge
    const tooltipTop = iconRect.top - tooltipRect.height - 6;
    if (tooltipTop < 10) {
      // Show tooltip below the icon instead
      tooltip.style.bottom = 'auto';
      tooltip.style.top = '100%';
      tooltip.style.marginBottom = '0';
      tooltip.style.marginTop = '6px';
      
      // Adjust arrow position
      const arrow = tooltip.querySelector('.reference-tooltip-arrow');
      if (arrow) {
        arrow.style.top = 'auto';
        arrow.style.bottom = '100%';
        arrow.style.borderTop = 'none';
        arrow.style.borderBottom = '6px solid #fff';
      }
    } else {
      // Reset arrow position for above positioning
      const arrow = tooltip.querySelector('.reference-tooltip-arrow');
      if (arrow) {
        arrow.style.top = '100%';
        arrow.style.bottom = 'auto';
        arrow.style.borderBottom = 'none';
        arrow.style.borderTop = '6px solid #fff';
      }
    }

    // Additional check to ensure tooltip doesn't go off bottom of viewport
    const tooltipBottom = iconRect.bottom + tooltipRect.height + 6;
    if (tooltipBottom > viewportHeight - 10 && tooltip.style.top === '100%') {
      // If showing below and would go off bottom, show above instead
      tooltip.style.bottom = '100%';
      tooltip.style.top = 'auto';
      tooltip.style.marginBottom = '6px';
      tooltip.style.marginTop = '0';
      
      // Reset arrow position
      const arrow = tooltip.querySelector('.reference-tooltip-arrow');
      if (arrow) {
        arrow.style.top = '100%';
        arrow.style.bottom = 'auto';
        arrow.style.borderBottom = 'none';
        arrow.style.borderTop = '6px solid #fff';
      }
    }
  }
}

// Initialize tooltips when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new ReferenceTooltip();
});

// Re-initialize tooltips for dynamic content (like AJAX-loaded content)
document.addEventListener('shopify:section:load', () => {
  new ReferenceTooltip();
}); 